<template>
    <div id="dashboard">
        <div id="side-bar">
            <div class="filter">
                <b-form-group>
                    <b-form-radio-group stacked v-model="selectedType" name="group-filter"
                        @input="onFilterChanged"
                        :options="options">
                    </b-form-radio-group>
                    <b-form-select v-model="selectedLocation" :options="locationOptions"
                      @input="onFilterChanged"
                      class="my-1" />
                </b-form-group>
            </div>
            <div class="queue">
                <b-list-group>
                    <b-list-group-item v-for="item in cases" :key="item.filename" button @click="onCaseClick(item)"
                        :active="item.filename === activeItem.filename">
                        <b-container fluid>
                            <b-row align-h="start">
                                <b-col md="auto">
                                    <b-badge>{{item.code}}</b-badge>
                                </b-col>
                                <b-col md="auto">
                                    {{item.uploader_name}}
                                </b-col>
                            </b-row>
                            <b-row align-h="start" class="mt-2">
                                <b-col md="auto">
                                    <div class="resolution-status" :class="getIndicatorColorClass(item.review_status)"></div>
                                </b-col>
                                <b-col>
                                    <div class="rejection-reason" v-if="item.review_status === 'rejected'">
                                        {{item.rejection_reason}}
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
        <div id="review-content">
            <b-container class="justify-content-md-center" v-if="activeItem">
                <b-row align-h="center"><video :src="activeItem.videoUrl" controls></video></b-row> 
                <b-row class="mt-5"></b-row>
                <b-row v-if="activeItem.review_status === 'unreviewed'">
                    <b-col md="auto">
                        <b-button size="lg" variant="success" @click="acceptItem">Accept</b-button>
                    </b-col>
                    <b-col>
                        <b-button size="lg" variant="danger" @click="rejectItem">Reject</b-button>
                        <b-form-select v-model="activeItem.rejection_reason" :options="rejectionOptions" class="mt-2"/>
                        <b-form-textarea
                            v-model="reasonText"
                            placeholder="Reasoning text (email)"
                            :rows="3"
                            class="mt-2"
                            :max-rows="6">
                        </b-form-textarea>
                    </b-col>
                </b-row>
                <b-row v-else class="mb-3" v-for="reviewer in activeItem.reviewers" :key="reviewer.email">
                  <b-col>
                    {{ reviewer.review_time | moment('DD.MM.YYYY HH:mm') }}
                  </b-col>
                  <b-col :class="getIndicatorColorClass(reviewer.review_status, true)">
                    {{ reviewer.review_status.toUpperCase() }}
                  </b-col>
                  <b-col>
                    {{ reviewer.email }}
                  </b-col>
                  <b-col>
                    {{ reviewer.organization === 'SAP' ? 'SAP' : 'Red Bull' }}
                  </b-col>
                  <b-col>
                    {{ reasonText }}
                  </b-col>
                </b-row>
            </b-container>
            <b-alert :variant="currentStatus.type" :show="currentStatus.visible">{{currentStatus.message}}</b-alert>
        </div>
    </div>
</template>

<script>
import io from 'socket.io-client';

export default {
  data() {
    return {
      selectedType: 'unreviewed',
      selectedLocation: 'sunrise',
      options: [
        {text: 'Accepted', value: 'accepted'},
        {text: 'Rejected', value: 'rejected'},
        {text: 'Unreviewed', value: 'unreviewed'}
      ],
      locationOptions: [
        {text: 'Munich (Germany)', value: 'munich'},
        {text: 'Sunrise (USA)', value: 'sunrise'},
        {text: 'Taoyuan (Taiwan)', value: 'taoyuan'}
      ],
      rejectionOptions: [
        {text: 'Please select a reason', value: undefined},
        {text: 'Obscene/X-Rated content', value: 'obscenity'},
        {text: 'Violent content', value: 'violence'},
        {text: 'Political content', value: 'political'},
        {text: 'Religious discrimination', value: 'discrimination'},
        {text: 'Quality reasons', value: 'quality'}
      ],
      cases: [],
      activeItem: false,
      currentStatus: {
        type: 'success',
        visible: false,
        message: ''
      },
      socket: io('localhost:3000?token=' + this.$store.state.auth.token)
    }
  },
  created () {
    this.loadCases()
  },
  methods: {
    onFilterChanged: function () {
      this.activeItem = false
      this.loadCases()
    },
    loadCases: function () {
      this.$http.get(`/private/${this.selectedType}?location=${this.selectedLocation}`)
        .then(response => {
          this.cases = response.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    getIndicatorColorClass: function (status, textColor) {
      if (status === 'unreviewed') {
        return textColor ? 'text-warning' : 'bg-warning'
      } else if (status === 'accepted') {
        return textColor ? 'text-success' : 'bg-success'
      }
      return 'bg-danger'
    },
    onCaseClick: function (item) {
      this.$http.get(`/private/video/info/${item.id}`)
        .then(response => {
          item.videoUrl = response.data.url
          item.reviewers = response.data.reviewers
          this.activeItem = item
        })
        .catch(err => {
          console.log(err)
        })
    },
    acceptItem: function () {
      this.$http.post(`/private/video/accept/${this.activeItem.id}`)
        .then(() => {
          this.cases = this.cases.filter(item => item.filename !== this.activeItem.filename)
          this.activeItem = false
          this.currentStatus.message = 'The video was succesfully accepted'
          this.currentStatus.type = 'success'
          this.currentStatus.visible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    rejectItem: function () {
      if (this.activeItem.rejection_reason && this.activeItem.rejection_text.length > 0) {
        this.currentStatus.visible = false
        this.$http.post(`/private/video/reject/${this.activeItem.id}`, {
          rejection_reason: this.activeItem.rejection_reason,
          rejection_text: this.activeItem.rejection_text
        })
          .then(() => {
            this.cases = this.cases.filter(item => item.filename !== this.activeItem.filename)
            this.activeItem = false
            this.currentStatus.message = 'The video was succesfully rejected'
            this.currentStatus.type = 'success'
            this.currentStatus.visible = true
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.currentStatus.message = 'Please provide a reason for your rejection'
        this.currentStatus.type = 'danger'
        this.currentStatus.visible = true
      }
    }
  },
  computed: {
    reasonText: {
      get: function () {
        switch (this.activeItem.rejection_reason) {
        case 'obscenity':
          return 'This video contains obscene or x-rated content'
        case 'violence':
          return 'This video contains violence'
        case 'political':
          return 'This video contains political statements'
        case 'discrimination':
          return 'This video is discriminating'
        case 'quality':
          return 'This video does not meet quality standards'
        default: 
          return ''
        }
      },
      set: function (value) {
        this.activeItem.rejection_text = value
        console.log(this.activeItem)
      }
    }
  }
}
</script>

<style>
html, body, #q-app, #dashboard {
    height: 100%
}
#dashboard {
    padding-left: 350px;
}
#side-bar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    border-right: 1px solid grey;
    width: 350px;
}
#review-content {
    height: 100%;
    width: 100%;
    padding: 50px;
}
.filter {
    padding: 30px 20px;
}
.filter .custom-radio {
    margin: 10px 0px;
}
.resolution-status {
    padding: 8px;
    border-radius: 8px;
}
.rejection-reason {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 12px;
}
.list-group-item.active {
    background-color: grey;
    border-color: grey;
}
</style>


